import { isElectron } from "@/lib/platform";
import { type UseDocumentPipOptions, useDocumentPip } from "./use-document-pip";
import { type UseElectronPipOptions, useElectronPip } from "./use-electron-pip";

export type UsePipOptions = UseDocumentPipOptions & UseElectronPipOptions;

export type UsePipReturn = {
	isSupported: boolean;
	isPipActive: boolean;
	pipWindow: Window | null;
	openPip: () => Promise<boolean>;
	closePip: () => void;
	pipContainerRef: React.RefObject<HTMLDivElement | null>;
};

export function usePip(options: UsePipOptions = {}): UsePipReturn {
	const documentPip = useDocumentPip(options);
	const electronPip = useElectronPip(options);

	if (isElectron) {
		return {
			...electronPip,
			openPip: async () => electronPip.openPip(),
		};
	}

	return documentPip;
}
